import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * 基础路由
 * @type { *[] }
 */
export var constantRouterMap = [{
  path: '/',
  component: function component() {
    return import('@/views/layouts/index');
  },
  redirect: '/home',
  meta: {
    title: '官方二手车',
    keepAlive: false
  },
  children: [{
    path: '/home',
    name: 'Home',
    component: function component() {
      return import('@/views/home/home');
    },
    meta: {
      title: '官方二手车',
      keepAlive: false
    }
  }, {
    path: '/key-valuation',
    name: 'key-valuation',
    component: function component() {
      return import('@/views/valuation/key-valuation');
    },
    meta: {
      title: '一键估价',
      keepAlive: false
    }
  }, {
    path: '/valuation-result',
    name: 'valuation-result',
    component: function component() {
      return import('@/views/valuation/valuation-result');
    },
    meta: {
      title: '估价结果',
      keepAlive: false
    }
  }, {
    path: '/car-model-selection',
    name: 'car-model-selection',
    component: function component() {
      return import('@/views/public/car-model-selection');
    },
    meta: {
      title: '车型选择',
      keepAlive: false
    }
  }, {
    path: '/buy-car',
    name: 'buy-car',
    component: function component() {
      return import('@/views/buy/buy-car');
    },
    meta: {
      title: '我要买车',
      class: 'buy-car',
      keepAlive: true
    }
  }, {
    path: '/sell-car',
    name: 'sell-car',
    component: function component() {
      return import('@/views/sell/sell-car');
    },
    meta: {
      title: '我要卖车',
      keepAlive: false
    }
  }, {
    path: '/certification-search',
    name: 'certification-search',
    component: function component() {
      return import('@/views/certification-search/certification-search');
    },
    meta: {
      title: '认证查询',
      keepAlive: false
    }
  }, {
    path: '/good-car-reservation',
    name: 'good-car-reservation',
    component: function component() {
      return import('@/views/buy/good-car-reservation');
    },
    meta: {
      title: '好车预约',
      class: 'good-car-reservation',
      keepAlive: false
    }
  }, {
    path: '/looking-same-car',
    name: 'looking-same-car',
    component: function component() {
      return import('@/views/buy/looking-same-car');
    },
    meta: {
      title: '找同款',
      keepAlive: false
    }
  }, {
    path: '/product-details',
    name: 'product-details',
    component: function component() {
      return import('@/views/product/product-details');
    },
    meta: {
      title: '产品详情',
      keepAlive: false
    }
  }, {
    path: '/store',
    name: 'store',
    component: function component() {
      return import('@/views/store/store');
    },
    meta: {
      title: '店铺',
      keepAlive: false
    }
  }, {
    path: '/replace-result',
    name: 'replace-result',
    component: function component() {
      return import('@/views/replacement/replace-result');
    },
    meta: {
      title: '我要置换',
      keepAlive: false
    }
  }, {
    path: '/replacement',
    name: 'replacement',
    component: function component() {
      return import('@/views/replacement/replacement');
    },
    meta: {
      title: '我要置换',
      keepAlive: false
    }
  }, {
    path: '/brand-select',
    name: 'brand-select',
    component: function component() {
      return import('@/views/replacement/brand-select');
    },
    meta: {
      title: '选择品牌',
      keepAlive: false,
      class: 'brand-select'
    }
  }, {
    path: '/carseries-select',
    name: 'carseries-select',
    component: function component() {
      return import('@/views/replacement/carseries-select');
    },
    meta: {
      title: '选择车系',
      keepAlive: false,
      rightBtn: 'modelOther'
    }
  }, {
    path: '/model-select',
    name: 'model-select',
    component: function component() {
      return import('@/views/replacement/model-select');
    },
    meta: {
      title: '选择车型',
      keepAlive: false
    }
  }, {
    path: '/store-select',
    name: 'store-select',
    component: function component() {
      return import('@/views/replacement/store-select');
    },
    meta: {
      title: '选择门店',
      keepAlive: false,
      class: 'store-select'
    }
  }, {
    path: '/store-select-map',
    name: 'store-select-map',
    component: function component() {
      return import('@/views/replacement/store-select-map');
    },
    meta: {
      title: '选择门店',
      keepAlive: false
    }
  }, {
    path: '/authorized-stores',
    name: 'authorized-stores',
    component: function component() {
      return import('@/views/authorized/authorized-stores');
    },
    meta: {
      title: '授权门店',
      class: 'authorized-stores',
      keepAlive: false
    }
  }]
}];